/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { ViewScopeContainer as ViewScope } from './ViewScope.container';
